export default "__VITE_ASSET__3N51SZyg__"